import React from 'react';
import styled from 'styled-components';
import Page from '../components/Page';
import { translate } from 'react-switch-lang';
import XingLogo from '../assets/xing.png';

// STYLES
const XingImage = styled.img`
  width: 64px;
  height: 59px;
`;

const Flex = styled.div`
  display: flex;
  align-items: center;

  p {
    margin: 0;
    padding-right: 20%;
    font-weight: bold;
  }
`;

// COMPONENT
const Home = props => {
  
  const { data } = props;

  return (
    <Page title="Kontakt">
      <img src={ process.env.REACT_APP_ROOT + data.image.path } alt="Rebekka Preuß - 0176-63243132 - rp@sprechbox.com" />
      <Flex>
        <p dangerouslySetInnerHTML={{ __html: data.text }}></p>
        <a href="https://www.xing.com/profile/Rebekka_Preuss" target="_blank" rel="noopener noreferrer"><XingImage src={XingLogo} alt="Xing Logo" /></a>
      </Flex>
    </Page>
  );
};

export default translate(Home);